import React from 'react';
import Icon from "../../Icon";
//import TagOption from "../../TagOptions";
//import TagList from "../../TagList";
import {PageLoader} from "../../Loader";
import loadable from "@loadable/component";
//import Modal from "../../Modal";
//import {Button} from "../../Button";
//import {config} from "../../../../config";
const DraftTextareaEditor = loadable(() => import("../../editor/DraftTextareaEditor"));

class MediaDatas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleMoreTag: false,
            mediaType: 0,
            content: "",
            contentRaw: {},
            mediaTag: [],
            contentReview : 0
        };

        this.editorRef = React.createRef();

        this.handleTags = this.handleTags.bind(this);
        this.handleMediaHotnessTag = this.handleMediaHotnessTag.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.currentMediaIndex !== this.props.currentMediaIndex){
            this.editorRef.current.updateContent(this.props.currentMedia.contentRaw);
        }
    }

    handleMediaHotnessTag(selectedTag){
        this.props.handleTags("mediaHotness", selectedTag);
    }

    handleTags(SelectTags) {
        let currentTags = [...this.props.currentMedia.tags, ...SelectTags];
        currentTags = Array.from(new Set(currentTags.map(a => a.title)))
            .map(id => {
                return currentTags.find(a => a.title === id)
            });
        this.props.handleTags("tags", currentTags);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.state !== nextState){
            return true;
        }
        if(this.props.currentMedia !== nextProps.currentMedia){
            return true;
        }
        if(this.props.currentMediaIndex !== nextProps.currentMediaIndex){
            return true;
        }
        return this.props.mediaInitialized !== nextProps.mediaInitialized;
    }

    render() {
        return !this.props.currentMedia ? (
                <PageLoader/>
            ) : (
            <div className={`media-datas-wrapper ${this.props.toggleMediaInformations ? 'active' : this.props.toggleMediaInformations === false ? 'hidden' : this.props.toggleMediaInformations === 'undefined' && ''}`}>
                <div className={"informations"}>
                    <div className={"category-title"}><Icon type={"pencil"}/> Informations</div>
                    {this.props.currentMedia.kind === "video" ? <div className={"category-title"}>ASTUCE : Une fois votre vidéo encodée, vous pouvez modifier sa vignette en allant l'éditer.</div> : null }
                    <input type={"text"} className={this.props.currentMedia.title.trim().length === 0 ? 'error' : ''}
                           placeholder={"(Titre obligatoire)"} name={"title"}
                           value={this.props.currentMedia && this.props.currentMedia.title}
                           onBlur={()=>this.props.handleCurrentMedia("title", this.props.currentMedia.title.trim())}
                           onChange={(event) => this.props.handleCurrentMedia("title", event.target.value)} required/>
                    {this.props.currentMedia.title.length === 0 &&
                    <div className={"error-text"}>Choisissez un titre qui décrit votre média.</div>}
                    <DraftTextareaEditor defaultValue={this.props.currentMedia.contentRaw}
                                         placeholder={"Description"}
                                         ref={this.editorRef}
                                         onChange={(contentRaw) => this.setState({contentRaw}, ()=>this.props.handleCurrentMedia("contentRaw", this.state.contentRaw))}/>
                </div>
                {/*<div className={"tag-wrapper"}>
                    <div className={"category-title"}><Icon type={"tags"}/> Temperature *</div>
                    <ul className={`filter ${this.props.currentMedia.contentReview === 0 ? 'error' : ''}`}>
                        {config.contentReview.map((item, index) => <li key={index}
                                                                        className={`${this.props.currentMedia.contentReview === item._id ? 'active' : ''}`}
                                                                        onClick={() => this.props.handleCurrentMedia("contentReview", item._id)}>{item.title}</li>)}
                    </ul>
                    {this.props.currentMedia.contentReview === 0 &&
                    <div className={"error-text h-45"}>Vous devez choisir une température pour votre média</div>}
                    {this.props.currentMedia.contentReview === 1 && (
                        <ul className="temperature-information">
                            <li>Vous êtes habillé(e) ou nu(e)</li>
                            <li>On ne voit pas votre sexe (pénis/minou)</li>
                            <li>Il n'y a pas d'acte sexuel (pénétration, fellation, masturbation)</li>
                        </ul>
                    )}
                    {this.props.currentMedia.contentReview === 2 && (
                        <ul className="temperature-information">
                            <li>Votre sexe n'apparait pas en gros plan</li>
                        </ul>
                    )}
                    {this.props.currentMedia.contentReview === 3 && (
                        <ul className="temperature-information">
                            <li>Votre sexe apparait en gros plan</li>
                        </ul>
                    )}
                    {/*<div className={"category-title mt-16"}><Icon type={"tags"}/> Tag</div>
                    {this.props.currentMedia.tags && this.props.currentMedia.tags.length >= 1 ?
                        <TagList tags={this.props.currentMedia.tags}/> : (<div className={"no-content cursor-pointer"}
                                                             onClick={() => this.setState({toggleMoreTag: true})}>Ajouter
                            un tag</div>)}
                    {this.props.currentMedia.tags && this.props.currentMedia.tags.length >= 1 && (
                        <Button btnStyle={"primary-reverse"}
                                size={"small"}
                                onClick={() => this.setState({toggleMoreTag: true})}
                                content={"Ajouter des tags"} />
                    )}*/}
                {/*}</div>*/}
                {/*<Modal toggle={this.state.toggleMoreTag}
                       handleClose={() => this.setState({toggleMoreTag: false})}>
                    <TagOption handleClose={() => this.setState({toggleMoreTag: false})}
                               currentTags={this.props.currentMedia.tags}
                               handleTags={this.handleTags}/>
                </Modal>*/}
            </div>
        )
    }
}

export default MediaDatas;